import { render, staticRenderFns } from "./ChangeLogMobile.vue?vue&type=template&id=40332fc4"
import script from "./ChangeLogMobile.vue?vue&type=script&lang=js"
export * from "./ChangeLogMobile.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogMobile.vue?vue&type=style&index=0&id=40332fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports